import * as React from 'react'
const SvgComponent = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 154 120"
    fill="currentColor"
    preserveAspectRatio="xMidYMid meet"
  >
    <g clipPath="url(#clip0_26613_802)">
      <path d="M68.09 25H11.11C4.978 25 .007 30.06.007 36.303v58.692h3.991V81.888h71.211v13.106H79.2V36.303C79.2 30.06 74.228 25 68.095 25h-.006Z" />
      <path
        fill="#fff"
        d="M11.011 54.884h87.134V88.45H0V66.09c0-6.186 4.933-11.207 11.011-11.207Z"
      />
      <path
        d="M11.011 54.884h87.134V88.45H0V66.09c0-6.186 4.933-11.207 11.011-11.207Z"
        opacity={0.5}
      />
      <path
        d="M109.156 54.884h40.852V88.45H98.145V66.09c0-6.186 4.933-11.207 11.011-11.207Z"
        opacity={0.75}
      />
      <path
        fill="#fff"
        d="M98.145 54.884h44.844c6.078 0 11.011 5.02 11.011 11.207v15.802H98.145V54.884ZM34.714 37.081H12.289c-1.52 0-2.753 1.255-2.753 2.802v12.2c0 1.547 1.232 2.801 2.753 2.801h22.425c1.52 0 2.752-1.254 2.752-2.802V39.883c0-1.547-1.232-2.802-2.752-2.802ZM66.911 37.081H44.486c-1.52 0-2.753 1.255-2.753 2.802v12.2c0 1.547 1.233 2.801 2.753 2.801h22.425c1.52 0 2.753-1.254 2.753-2.802V39.883c0-1.547-1.233-2.802-2.753-2.802Z"
      />
      <path d="M142.895 47.941h-37.637c-6.133 0-11.105 5.06-11.105 11.302V95h3.992V81.893h51.863V95H154V59.243c0-6.242-4.972-11.302-11.105-11.302Z" />
    </g>
    <defs>
      <clipPath id="clip0_26613_802">
        <path fill="#fff" d="M0 0h154v120H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
